"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// Modules
const react_1 = require("react");
// Components
const CarouselArrows_1 = __importDefault(require("./CarouselArrows/CarouselArrows"));
// Styled
const Styled = __importStar(require("./Styled"));
function Carousel(props) {
    var _a;
    if (!props.items.length) {
        return null;
    }
    const testId = `${props.testId}-Carousel`;
    const [hasScrolling, setHasScrolling] = (0, react_1.useState)(false);
    const [trigger, setTrigger] = (0, react_1.useState)(false); // utilizado para nao chamar a funçao handleHorizontalInfiniteScroll muitas vezes
    const carouselRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const carouselWidth = ((_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) || 0;
        const screenWidth = ((_b = carouselRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
        if (carouselWidth > screenWidth) {
            setHasScrolling(true);
        }
        else {
            setHasScrolling(false);
        }
        setTrigger(false);
    }, [carouselRef, props.items]);
    const setNewScrollPosition = (newScrollPosition) => {
        var _a;
        const start = ((_a = carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) || 0;
        const change = newScrollPosition - start;
        const increment = 2;
        const duration = 100;
        let currentTime = 0;
        const easeInOutQuad = function (t, b, c, d) {
            t /= d / 2;
            if (t < 1)
                return (c / 2) * t * t + b;
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        };
        const animateScroll = () => {
            currentTime += increment;
            const val = easeInOutQuad(currentTime, start, change, duration);
            // @ts-ignore
            carouselRef.current.scrollLeft = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
            else {
                // @ts-ignore
                carouselRef.current.scrollLeft = newScrollPosition;
            }
        };
        animateScroll();
    };
    const onScrollCarousel = (e) => {
        var _a, _b;
        const carouselWidth = ((_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) || 0;
        const screenWidth = ((_b = carouselRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
        const totalScrollWidth = carouselWidth - screenWidth;
        const percentScrolled = 
        // @ts-ignore
        ((e.target.scrollLeft || 0) * 100) / totalScrollWidth;
        if (percentScrolled > 75 && props.handleHorizontalInfiniteScroll && !trigger) {
            setTrigger(true);
            props.handleHorizontalInfiniteScroll();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Styled.Wrapper, Object.assign({ "data-testid": testId }, { children: [(0, jsx_runtime_1.jsxs)(Styled.Carousel, Object.assign({ ref: carouselRef, hasScrolling: hasScrolling, onScroll: onScrollCarousel, space: props.space, lightMode: props.arrowsLightMode }, { children: [props.items.map((item, index) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `carousel-item index-${index}` }, { children: item }), index))), (0, jsx_runtime_1.jsx)("div", {})] })), !!props.items.length && hasScrolling && ((0, jsx_runtime_1.jsx)(Styled.Footer, { children: (0, jsx_runtime_1.jsx)(CarouselArrows_1.default, { elementSize: (((_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) || 0) / props.items.length, carouselRef: carouselRef.current, setNewScrollPosition: setNewScrollPosition, testId: testId, lightMode: props.arrowsLightMode }) }))] })));
}
exports.default = Carousel;
